/* Built In Imports */

/* External Imports */
import { Box, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';
import SimpleButton from '@lb/components/Buttons/SimpleButton';

/* Styles */
/* Services */

/**
 * Renders StickyGroup Component
 *
 * @param {object} Button Group
 * @returns {ReactElement} StickyGroup Component
 */

const StickyGroup = ({ sectionContent, region, language }) => {
  const colors = ['#AE3A2E', '#36643B', '#BC831C']; // Array of colors for buttons
  return (
    <>
      <Box
        display="flex"
        textAlign="center"
        m={{ base: '0 auto 0 auto', md: '-89px auto 0px auto' }}
        // w={{ base: '100%', md: '830px' }}
        flexDirection={'row'}
        alignItems="start"
        maxW={{ base: 'unset', md: '812px' }}
        // textTransform={'uppercase'}
        // fontFamily={'FedraSansStd-A-medium'}
        fontSize={{ base: '16px', md: '18px' }}
        lineHeight={{ base: '20px' }}
        // sx={{
        //   'a:first-letter': {
        //     fontSize: '18px',
        //   },
        //   body: {
        //     padding: '0px !important',
        //   },
        // }}
        position={{ base: 'fixed', md: 'relative' }}
        bottom={{ base: '0', md: 'unset' }}
        zIndex={'1000'}
        justifyContent="center"
        width={'100%'}
      >
        {sectionContent.buttonGroup.map((button, index) => (
          <>
          {button.buttonText !== '' && (
          <Box
            width={{ base: '100%', md:'275px' }}
            color={'#ffffff'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            className='stickybtn'
          >
            <SimpleButton
              style={button}
              region={region}
              lang={language}
              mx="0"
              width={{base:'100%', md:'262px'}}
              bgColor={colors[index]}
            />
          </Box>
          )}
          </>
        ))}
      </Box>
      <style>
        {`
          .footer{
            padding: 0 0 68px;
          }
          .stickybtn button {
            border-left: none;
            font-size: 18px;
            letter-spacing: 0;
            font-variant: none;
            border-radius: 0;
            margin-top: 0;
            margin-bottom: 0;
          }
          .stickybtn button {
            width: 262px;
            font-family: FedraSansStd-A-medium;
            padding: 0;
            height: 68px;
          }
          @media (max-width: 768px) {
          .stickybtn button {
            font-size: 16px;
            width: 100%;
          }
        }
        `}
      </style>
    </>
  );
};

export default StickyGroup;
